import * as React from 'react'

import NotFoundPage from '@/components/common/not-found-page'

interface ClientErrorBoundaryProps {
  children: React.ReactNode
}

interface ClientErrorBoundaryState {
  hasError: boolean
}

/**
 * Catches client-side render errors so production does not show the generic Next.js application error screen.
 */
export default class ClientErrorBoundary extends React.Component<
  ClientErrorBoundaryProps,
  ClientErrorBoundaryState
> {
  state: ClientErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ClientErrorBoundaryState {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <NotFoundPage />
    }

    return this.props.children
  }
}
